import { all, call, select } from 'redux-saga/effects';
import { getServerConfig } from './selectors';
import { API } from '../../../api';

export function* fetchDataStreams(dataStreamConfigs, parcelId) {
  if (!parcelId || !dataStreamConfigs.length) return null;

  const requests = {};
  const serverConfig = yield select(getServerConfig);

  dataStreamConfigs.forEach((config) => {
    const { dataStreamId } = config;

    const path = `/data-stream/${serverConfig.namespace}/${dataStreamId}/${parcelId}`;

    requests[dataStreamId] = call(API, 'get', 'api', path);
  });

  const results = yield all(requests);

  const dataStreamHash = {};
  dataStreamConfigs.forEach((config) => {
    dataStreamHash[config.dataStreamId] = {
      ...config,
      ...results[config.dataStreamId],
    };
  });

  return dataStreamHash;
}
